export default "__VITE_ASSET__EESQnHbR__"